<template>
  <div class="verify-reset-token-mail">
    <section-header class="mt-5 mb-5" title="重設密碼" subtitle="Reset Password"/>
    <section class="row justify-content-center mt-5 mb-5">
      <div class="col-lg-4 col-md-6 col-12">
        <div>重設{{ email }}密碼</div>
        <form class="row needs-validation">
          <div class="col-12 mt-5">
            <div class="form-floating">
              <input id="input-passwd" type="password" class="form-control" :class="validation.password.class" placeholder="密碼" maxlength="64" v-model="password">
              <label for="input-passwd" class="text-secondary">密碼</label>
              <div class="invalid-feedback">{{ validation.password.feedback }}</div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-floating">
              <input id="input-chkpasswd" type="password" class="form-control" :class="validation.checkPassword.class" placeholder="確認密碼" maxlength="64" v-model="checkPassword">
              <label for="input-chkpasswd" class="text-secondary">確認密碼</label>
              <div class="invalid-feedback">{{ validation.checkPassword.feedback }}</div>
            </div>
          </div>
          <div class="col-12 mt-5 pb-5">
            <button class="btn btn-lg btn-dark w-100" type="button" @click="onSubmitted">確認</button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import constant from '@/constant.js'
import authApi from '@/api/auth.js'
import SectionHeader from '@/components/SectionHeader.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'VerifyResetTokenMail',
  components: {
    SectionHeader
  },
  data: function () {
    return {
      password: null,
      checkPassword: null,
      validation: {
        password: { class: null, feedback: null },
        checkPassword: { class: null, feedback: null }
      }
    }
  },
  watch: {
    password: function (value) {
      this.validation.password.class = null
    },
    checkPassword: function (value) {
      this.validation.checkPassword.class = null
    }
  },
  computed: {
    verifyToken: function () {
      return this.$route.query.verifyToken
    },
    email: function () {
      return this.$route.query.email
    }
  },
  methods: {
    ...mapMutations([
      'setAlert'
    ]),
    apiResetPassword: function () {
      var self = this
      authApi.resetPassword(this.verifyToken, this.email, this.password, function (err, rspData) {
        if (err) {
          self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: '無法重設密碼' })
          return
        }
        self.setAlert({ type: constant.ALERT_TYPE.INFO, msg: '重設密碼完成，請重新登入' })
        self.$router.push('/w/sign-in')
      })
    },
    onSubmitted: function () {
      // check password
      if (!this.password) {
        this.validation.password.class = 'is-invalid'
        this.validation.password.feedback = '請輸入密碼'
        return
      } else if (!(this.password.length >= 8 && this.password.match(/[a-z]/) && this.password.match(/[A-Z]/) && this.password.match(/[0-9]/))) {
        this.validation.password.class = 'is-invalid'
        this.validation.password.feedback = '密碼需至少8碼，且包含英文大小寫及數字組合'
        return
      } else {
        this.validation.password.class = 'is-valid'
      }
      if (!this.checkPassword) {
        this.validation.checkPassword.class = 'is-invalid'
        this.validation.checkPassword.feedback = '請再次輸入密碼'
        return
      } else if (this.password !== this.checkPassword) {
        this.validation.checkPassword.class = 'is-invalid'
        this.validation.checkPassword.feedback = '兩次輸入密碼不相同'
        return
      } else {
        this.validation.checkPassword.class = 'is-valid'
      }
      this.apiResetPassword()
    }
  }
}
</script>
